import * as React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { APP_URLS } from '../../../App'
import { useAuth } from './AuthProvider'

interface ProtectedRouteProps {
  children?: React.ReactNode
}

const ProtectedRoute = ({ children }: ProtectedRouteProps): any => {
  const { authenticated } = useAuth()
  const loc = useLocation()

  if (!authenticated) {
    // console.log(`ProtectedRoute: not authenticated - redirecting to ${APP_URLS.auth_login}`)
    // console.log(`Redirecting from ${loc.pathname}`)
    return <Navigate to={APP_URLS.auth_login} replace state={{ from: loc.pathname }} />
  }

  // if (!checkAuthenticatedOnApi()) {
  //   return <Navigate to={APP_URLS.auth_login} replace />
  // }

  return <Outlet />
}

export default ProtectedRoute
